"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PointsFormat = void 0;
const data_type_1 = require("../data/data-type");
const config_name_1 = require("./config-name");
const config_type_1 = require("./config-type");
/**
 * Defines the Configurations available under the PointFormat table.
 */
class PointsFormat extends config_name_1.ConfigName {
    constructor(_name, _returnType) {
        super(_name, _returnType);
    }
    getConfigType() {
        return config_type_1.ConfigType.POINTS_FORMAT;
    }
}
exports.PointsFormat = PointsFormat;
/**
 * Pattern Strings to be used for formatting points amounts.
 */
PointsFormat.PATTERN = new PointsFormat('pattern', data_type_1.DataType.STRING);
//# sourceMappingURL=points-format.js.map